import createIcon from '../../createIcon';

/**
 * @component @name SendTimeExtension
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNi4yNUMxOSA1LjE1IDE4LjEgNC4yNSAxNyA0LjI1SDEzQzEzIDIuODcgMTEuODggMS43NSAxMC41IDEuNzVDOS4xMiAxLjc1IDggMi44NyA4IDQuMjVINC4wMUMyLjkxIDQuMjUgMi4wMSA1LjE1IDIuMDEgNi4yNVYxMC4wNUM0LjcgMTAuMDUgNSAxMi4yMSA1IDEyLjc1QzUgMTMuMjkgNC43MSAxNS40NSAyIDE1LjQ1VjE5LjI1QzIgMjAuMzUgMi45IDIxLjI1IDQgMjEuMjVINy44QzcuOCAxOS4wOSA5LjE3IDE4LjQ3IDEwIDE4LjMxVjkuMDFMMTkgMTMuNTFWNi4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAxMi4yNVYxNi4yNUwxNiAxNy4yNUwxMiAxOC4yNVYyMi4yNUwyMiAxNy4yNUwxMiAxMi4yNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SendTimeExtension = createIcon('SendTimeExtension', [
  [
    'path',
    {
      d: 'M19 6.25C19 5.15 18.1 4.25 17 4.25H13C13 2.87 11.88 1.75 10.5 1.75C9.12 1.75 8 2.87 8 4.25H4.01C2.91 4.25 2.01 5.15 2.01 6.25V10.05C4.7 10.05 5 12.21 5 12.75C5 13.29 4.71 15.45 2 15.45V19.25C2 20.35 2.9 21.25 4 21.25H7.8C7.8 19.09 9.17 18.47 10 18.31V9.01L19 13.51V6.25Z',
      key: 'wozray',
    },
  ],
  ['path', { d: 'M12 12.25V16.25L16 17.25L12 18.25V22.25L22 17.25L12 12.25Z', key: '1ptv0k' }],
]);

export default SendTimeExtension;
